import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Tabs } from '../../../../common/tabs'
import { getAppendStyleItemWithCustom } from '../../../../common/tabs/helper'
import TableNumberOfCompanies from './component/numberOfCompanies/TableNumberOfCompanies'
import TableRatioComparison from './component/ratioComparison/TableRatioComparison'
import TableSize from './component/size/TableSize'
import { selectCompareVal, selectData } from './store/slice'

const ViewByTable = () => {
  const data = useSelector(selectData)
  const compareVal = useSelector(selectCompareVal)
  const defaultIndustry = data[compareVal]?.defaultIndustry
  const [activeTab, setActiveTab] = useState('SIZE')
  const TABLE_TABS = [
    {
      label: 'companyAnalysis.industryAnalysis.SIZE_1',
      key: 'SIZE',
      children: <TableSize year={defaultIndustry?.sizeYear} />,
    },
    {
      label: 'companyAnalysis.industryAnalysis.NUMBER_OF_COMPANIES_1',
      key: 'NUMBER_OF_COMPANIES',
      children: <TableNumberOfCompanies year={defaultIndustry?.nocYear} />,
    },
    {
      label: 'companyAnalysis.industryAnalysis.RATIO_COMPARISON_1',
      key: 'RATIO_COMPARISON',
      children: <TableRatioComparison year={defaultIndustry?.ratioYear} />,
    },
  ]

  return (
    <div>
      <Tabs
        items={TABLE_TABS}
        isI18n
        activeKey={activeTab}
        onChange={setActiveTab}
        styleContent={{ height: 160, flex: 'auto' }}
        tabListStyle={{ gap: 0 }}
        getAppendStyleItem={getAppendStyleItemWithCustom()}
      />
    </div>
  )
}

export default ViewByTable
